import React from "react";

const TermsUse = (props) => {
    const {pageData, page} = props;

    const newState = pageData.filter((item, index) => {
        return item.slug === page
    }

)

function createMarkup(text) {
    return {__html: text};
}


return (
    <div className="menu-content-сontacts menu-content-item tab-parent screen-bottom-block">
        <div className="rounded-white-block">
            {
                newState.length ?
                <div>
                    <div className="white-block-top">
                        <h3>{newState[0].subtitle}</h3>
                    </div>
                    <div className="сontacts-info">
                        <div dangerouslySetInnerHTML={createMarkup(newState[0].content)} />
                    </div>
                </div>
                : ''
            }
        </div>
    </div>
);
}
export default TermsUse;


// WEBPACK FOOTER //
// ./src/components/Information/StaticPage.js